var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 11,
    "data-width-24": 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.227 15.768c.14.14.331.22.53.22h.09l4.07-.62a.78.78 0 0 0 .43-.22l8.482-8.482a.74.74 0 0 0 .323-.324l1.095-1.094a2.25 2.25 0 0 0 0-3.18l-1.41-1.41a2.25 2.25 0 0 0-3.18 0l-9.9 9.9a.78.78 0 0 0-.22.43l-.53 4.15a.73.73 0 0 0 .22.63M13.502 4.953l.685-.685a.75.75 0 0 0 0-1.06l-1.41-1.45a.75.75 0 0 0-1.06 0l-.706.704zM9.948 3.519l-7.991 7.959-.37 2.84 2.88-.33 7.975-7.975z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;